import { GetAllSubmittedTestsResponseDto } from '@/store/InstallationValidation/constants';
import { DateSelectorOptions, HistoryTestWrapper, LineBreak } from './HistoryTest.styles';
import { Dropdown, theme } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowIcon from '@/comp/common/icons/ArrowIcon';
import { formatTestDate } from '../../InstallationValidation.utils';

const { useToken } = theme;

export interface HistoryTestDropDownProps {
  historyTests: GetAllSubmittedTestsResponseDto[];
  testedBy: string;
  testId?: number;
  handleUpdateLastTestData: (testId: string) => void;
  testDate: string;
  isMobile?: boolean;
}

export const HistoryTestDropDown: React.FC<HistoryTestDropDownProps> = ({
  historyTests,
  testedBy,
  testId,
  testDate,
  isMobile = false,
  handleUpdateLastTestData,
}) => {
  const { t } = useTranslation();
  const { token } = useToken();

  const handleSelectHistoryTest = (testId: string) => {
    handleUpdateLastTestData(testId);
  };
  return (
    <HistoryTestWrapper $isMobile={isMobile}>
      {t('TESTED_BY')} {testedBy} {isMobile && <LineBreak $height={8} />}
      <span className="date-value-wrapper">{t('TEST_DATE_WITHOUT_FIELD')} </span>
      <Dropdown
        trigger={['click']}
        menu={{
          defaultSelectedKeys: [`${testId}`],
          selectable: true,
          onClick: ({ key }) => handleSelectHistoryTest(key),
          items: [
            ...historyTests.map(test => ({
              key: test.testId,
              label: <DateSelectorOptions>{formatTestDate(test?.endedAt?.toString())}</DateSelectorOptions>,
            })),
          ],
        }}
      >
        <span className="date-value">
          {testDate} <ArrowIcon color={token.colorPrimary} className="arrow-wrapper" />
        </span>
      </Dropdown>
    </HistoryTestWrapper>
  );
};
